import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { TransmissionsApi } from "@socotec.io/atm-back-sdk";

const api = new TransmissionsApi(atmBackConfiguration);

// L.B 21/07/26 `building_data` / `appendices` are stored verbatim by the serializer (generic
// dicts) and both the write validation and the transmit logics read snake_case
// keys (building_uuid, be_id, be_filename, be_file, type_document, zone_uuid).
const camelToSnake = (key) => key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);

const snakeCaseKeys = (dict) =>
  Object.fromEntries(Object.entries(dict).map(([key, value]) => [camelToSnake(key), value]));

export const fetchTransmissions = async ({ caseInfo, type, status } = {}) => {
  return await api.list({ caseInfo, type, status });
};

/**
 * @returns {Promise<object>} the created transmission (the transmit is dispatched
 *   server-side; a 502 is raised if the upstream service is unavailable)
 */
export const createTransmission = async (
  type,
  origin,
  buildingData,
  appendices,
  userUuid,
  caseInfo,
) => {
  const transmission = {
    caseInfo,
    userUuid,
    type,
    origin,
    buildingData: (buildingData || []).map(snakeCaseKeys),
    appendices: (appendices || []).map(snakeCaseKeys),
  };

  return await api.create({ transmissionRequest: transmission });
};
